import { render, staticRenderFns } from "./LayoutLeft.vue?vue&type=template&id=0bcb110a&scoped=true&"
import script from "./LayoutLeft.vue?vue&type=script&lang=js&"
export * from "./LayoutLeft.vue?vue&type=script&lang=js&"
import style0 from "./LayoutLeft.vue?vue&type=style&index=0&id=0bcb110a&prod&lang=css&"
import style1 from "./LayoutLeft.vue?vue&type=style&index=1&id=0bcb110a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcb110a",
  null
  
)

export default component.exports